import React from 'react';
import { MissingDocumentEditTemplate } from 'themes/application/missing-document/pages';
import { observer } from 'mobx-react';
import { MissingDocumentEditViewStore } from 'application/missing-document/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new MissingDocumentEditViewStore(rootStore), 'editView')
@observer
class MissingDocumentEdit extends React.Component {
    render() {
        return <MissingDocumentEditTemplate {...this.props} />
    }
}

export default MissingDocumentEdit;
